import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';

function HeaderRoot({ children }) {
  return (
    <AppBar elevation={0} color="inherit" position="sticky" sx={{ backdropFilter: 'blur(6px)', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: (t) => t.layout.header.height || 64 }}>
          {children}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

HeaderRoot.displayName = 'Header.Root';
export default HeaderRoot;
